import { render, staticRenderFns } from "./ModalVehicleCategoryNew.vue?vue&type=template&id=12bfc9d0&"
import script from "./ModalVehicleCategoryNew.vue?vue&type=script&lang=js&"
export * from "./ModalVehicleCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports